module.exports = __webpack_public_path__ + "img/title_uk.50e36445.svg";